class SearchOperator {
    static options = {
        isMultiSelect : false, 
        customInput : false, 
        customSuggestion : false, 
        isDate : false, 
        input : true, 
        disable : false, 
        results : [],
    }

    static equalsOperator(options = this.options) {
        return {
            id : "equals",
            value : "=",
            ...this.options,
            ...options,
        }
    }

    static containsOperator(options = this.options) {
        return {
            id : "contains",
            value : "contains",
            ...this.options,
            ...options,
        }
    }

    static startsWithOperator(options = this.options) {
        return {
            id : "startsWith",
            value : "starts with",
            ...this.options,
            ...options,
        }
    }

    static endsWithOperator(options = this.options) {
        return {
            id : "endsWith",
            value : "ends with",
            ...this.options,
            ...options,
        }
    }

    static inOperator(options = this.options) {
        return {
            id : "in",
            value : "in",
            ...this.options,
            ...options,
        }
    }

    static isOperator(options = this.options) {
        return {
            id : "is",
            value : "is",
            ...this.options,
            ...options,
        }
    }

    static betweenOperator(options = this.options) {
        return {
            id : "between",
            value : "> <",
            ...this.options,
            ...options,
        }
    }
}

export default SearchOperator;